export default __webpack_public_path__ + "static/media/00-sky.271f0396.gif";